import { createFileRoute } from "@tanstack/react-router";
import { AiAssistantPage } from "@/components/ai-assistant-page";
import { aiHead, aiLoader } from "@/components/ai-meta";

// Canonical URL (locale-prefixed) for the Beancount AI Assistant page.
export const Route = createFileRoute("/$locale/assistant")({
  loader: aiLoader,
  head: aiHead,
  component: AiAssistantPage,
});
